import { render, staticRenderFns } from "./CharacterProfile.vue?vue&type=template&id=57f1a76e&scoped=true"
import script from "./CharacterProfile.vue?vue&type=script&lang=js"
export * from "./CharacterProfile.vue?vue&type=script&lang=js"
import style0 from "./CharacterProfile.vue?vue&type=style&index=0&id=57f1a76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f1a76e",
  null
  
)

export default component.exports